import React, { useRef } from "react";
import { ListTodo } from "lucide-react";
import UserTaskTable from "./UserTaskTable/UserTaskTable";
import { useTranslation } from "react-i18next";

const UserTaskManagement = (props) => {
  const { t } = useTranslation();
  const userTaskTableRef = useRef(); // Create ref for UserTaskTable

  const handleRefreshDailyTasks = () => {
    if (userTaskTableRef.current) {
      userTaskTableRef.current.refreshTaskList(); // Call the exposed function
    }
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "8px",
                background: "rgba(255,255,255,0.16)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <ListTodo size={14} color="#fff" />
            </div>
            <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
              {t("task_management_header")}
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleRefreshDailyTasks();
            }}
            style={{
              background: "rgba(255,255,255,0.16)",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              color: "white",
              padding: "6px 8px",
              borderRadius: "6px",
            }}
            title={t("refresh_daily_tasks_tooltip") || "Refresh Daily Tasks"}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
          </button>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <UserTaskTable ref={userTaskTableRef} />
        </div>
      </div>
    </>
  );
};

export default UserTaskManagement;
